import React, { useState } from "react";
import {
 Box,
 Button,
 Input,
 FormControl,
 FormLabel,
 Heading,
 VStack,
 useToast,
} from "@chakra-ui/react";
import Select from "react-select";
import axios from "axios";

const states = [
 "Karnataka",
 "Jammu and Kashmir",
 "Uttarakhand",
 "Arunachal Pradesh",
 "Meghalaya",
 "Himachal Pradesh",
 "Gujarat",
 "Assam",
 "Dadra and Nagar Haveli",
 "Kerala",
 "West Bengal",
 "Maharashtra",
 "Madhya Pradesh",
 "Delhi",
 "Rajasthan",
 "Bihar",
 "Sikkim",
 "Tamil Nadu",
 "Orissa",
 "Goa",
 "Andhra Pradesh",
 "Telangana",
 "Chhattisgarh",
 "Mizoram",
 "Punjab",
 "Jharkhand",
 "Uttar Pradesh",
];

const preferredStatesOptions = [
 "AKTU",
 "IPU",
 "Maharastra colleges",
 "Bangalore colleges",
 "Deemed Universities",
 "Others",
];

const budgetOptions = [
 "No donation",
 "Donation",
 "Below 10 lakhs",
 "10-15 lakhs",
 "15-25 lakhs",
 "No issues with budget",
];

const formatOptions = (arr) => arr.map((value) => ({ label: value, value }));

const BtechInquiryForm = ({ onSuccess }) => {
 const [formData, setFormData] = useState({
  name: "",
  contactDetail: "",
  city: "",
  state: null,
  preferredStates: [],
  expectedBudget: [],
 });

 const toast = useToast();

 const handleSubmit = async (e) => {
  e.preventDefault();
  const payload = {
   name: formData.name,
   contactDetail: formData.contactDetail,
   city: formData.city,
   state: formData.state?.value,
   preferredStates: formData.preferredStates.map((item) => item.value),
   expectedBudget: formData.expectedBudget.map((item) => item.value),
  };

  try {
   await axios.post(
    "https://admission-backend-theta.vercel.app/api/mbbs-inquiry/btech-inquiry",
    payload
   );
   setFormData({
    name: "",
    contactDetail: "",
    city: "",
    state: null,
    preferredStates: [],
    expectedBudget: [],
   });
   onSuccess();
  } catch (error) {
   toast({
    title: "Submission Failed",
    description: "Could not submit BTech inquiry.",
    status: "error",
    duration: 6000,
    isClosable: true,
   });
  }
 };

 return (
  <Box
   maxW="100%"
   mx="auto"
   mt={4}
   p={6}
   bg="white"
   borderRadius="2xl"
   boxShadow="lg"
  >
   <Heading mb={6} textAlign="center" size="lg" color="gray.700">
    BTech Inquiry Form
   </Heading>

   <form onSubmit={handleSubmit}>
    <VStack spacing={5}>
     <FormControl isRequired>
      <FormLabel color="gray.600">Name</FormLabel>
      <Input
       size="lg"
       placeholder="Enter your name"
       value={formData.name}
       onChange={(e) => setFormData({ ...formData, name: e.target.value })}
      />
     </FormControl>

     <FormControl isRequired>
      <FormLabel color="gray.600">Contact Detail</FormLabel>
      <Input
       size="lg"
       placeholder="Phone or Email"
       value={formData.contactDetail}
       onChange={(e) =>
        setFormData({ ...formData, contactDetail: e.target.value })
       }
      />
     </FormControl>

     <FormControl isRequired>
      <FormLabel color="gray.600">City</FormLabel>
      <Input
       size="lg"
       placeholder="Enter your city"
       value={formData.city}
       onChange={(e) => setFormData({ ...formData, city: e.target.value })}
      />
     </FormControl>

     <FormControl isRequired>
      <FormLabel color="gray.600">State</FormLabel>
      <Select
       styles={{
        control: (base) => ({
         ...base,
         padding: "2px",
         borderRadius: "10px",
         fontSize: "16px",
        }),
       }}
       options={formatOptions(states)}
       placeholder="Select your state"
       value={formData.state}
       onChange={(selectedOption) =>
        setFormData({ ...formData, state: selectedOption })
       }
      />
     </FormControl>

     <FormControl isRequired>
      <FormLabel color="gray.600">Preferred States</FormLabel>
      <Select
       isMulti
       styles={{
        control: (base) => ({
         ...base,
         padding: "2px",
         borderRadius: "10px",
         fontSize: "16px",
        }),
       }}
       options={formatOptions(preferredStatesOptions)}
       placeholder="Select preferred states"
       value={formData.preferredStates}
       onChange={(selectedOptions) =>
        setFormData({ ...formData, preferredStates: selectedOptions || [] })
       }
      />
     </FormControl>

     <FormControl isRequired>
      <FormLabel color="gray.600">Expected Total Budget</FormLabel>
      <Select
       isMulti
       styles={{
        control: (base) => ({
         ...base,
         padding: "2px",
         borderRadius: "10px",
         fontSize: "16px",
        }),
       }}
       options={formatOptions(budgetOptions)}
       placeholder="Select budget range"
       value={formData.expectedBudget}
       onChange={(selectedOptions) =>
        setFormData({ ...formData, expectedBudget: selectedOptions || [] })
       }
      />
     </FormControl>

     <Button
      type="submit"
      colorScheme="blue"
      size="lg"
      width="full"
      mt={4}
      borderRadius="lg"
      fontWeight="bold"
     >
      Submit Inquiry
     </Button>
    </VStack>
   </form>
  </Box>
 );
};

export default BtechInquiryForm;
